const url = `${process.env.REACT_APP_API_CONNECTION_ROOT}`;

export const getHealth = async () => {
  const requestOptions = {
    method: 'GET',
  };
  return fetch(url, requestOptions);
};
